import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

const ShieldAlert = (props: IIconProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.877 3.032a.82.82 0 0 1 .454 0l7.286 2.102c.346.1.583.413.583.768v4.311c0 4.876-3.16 9.205-7.843 10.746a.82.82 0 0 1-.512 0C7.16 19.418 4 15.089 4 10.211V5.902c0-.355.238-.668.583-.768l7.294-2.102Zm-.54 9.704-.24-3.56a26.293 26.293 0 0 1-.066-1.493c0-.412.108-.732.324-.963.216-.23.5-.345.854-.345.426 0 .712.148.855.442.144.296.217.72.217 1.275 0 .326-.018.658-.053.995l-.32 3.663c-.035.437-.109.77-.223 1.004a.585.585 0 0 1-.567.349c-.267 0-.455-.113-.557-.338-.106-.225-.18-.569-.224-1.03Zm.033 4.596c.226.196.49.293.793.293.29.003.57-.103.783-.297.223-.198.335-.47.335-.817 0-.307-.113-.57-.332-.784a1.103 1.103 0 0 0-.8-.324c-.314 0-.578.108-.794.324a1.067 1.067 0 0 0-.324.784c0 .351.113.625.34.82Z"
    />
  </Icon>
);

export default ShieldAlert;
